import $ from 'jquery';

import Monitoring from 'shared_modules/Monitoring';

const MultiCurrencyFieldBase = (): MultiCurrencyFieldBase => {
  const fieldWrapperSelector = '.money-field-container';
  const multiCurrencyClass = 'is-multi-currency';
  const multiCurrencySymbolDataSelector = 'data-currencysymbol';

  const replaceCurrencySymbol = ({
    currencyCodes = [],
    currencySymbols = [],
    targetSelector,
  }: MultiCurrencyReplaceCurrencySymbolInput) => {
    const targetField = $(targetSelector);
    const currencyCodesLength = currencyCodes.length;
    const currencySymbolsLength = currencySymbols.length;

    try {
      if (!targetField.length) {
        throw new Error(`${targetSelector} element does not exist.`);
      }

      if (!currencyCodesLength && !currencySymbolsLength) {
        throw new Error(`${targetSelector} has missing currency data.`);
      }

      if (currencyCodesLength) {
        const isSingle = currencyCodesLength === 1;

        if (!isSingle && currencyCodesLength !== targetField.length) {
          throw new Error(`${targetSelector} has mismatching currency codes.`);
        }

        targetField.each((index, field) => {
          const fieldEl = $(field);
          const currencyIndex = isSingle ? 0 : index;
          const currencyCode = currencyCodes[currencyIndex];
          const currencySymbol = window.merchantos.multiCurrency.getCurrencySymbol({
            currencyCode,
          });

          fieldEl
            .parents(fieldWrapperSelector)
            .addClass(multiCurrencyClass)
            .attr(multiCurrencySymbolDataSelector, currencySymbol);
        });

        return;
      }

      if (currencySymbolsLength) {
        const isSingle = currencySymbolsLength === 1;

        if (!isSingle && currencySymbolsLength !== targetField.length) {
          throw new Error(`${targetSelector} has mismatching currency symbols.`);
        }

        targetField.each((index, field) => {
          const fieldEl = $(field);
          const symbolIndex = isSingle ? 0 : index;

          fieldEl
            .parents(fieldWrapperSelector)
            .addClass(multiCurrencyClass)
            .attr(multiCurrencySymbolDataSelector, currencySymbols[symbolIndex]);
        });
      }
    } catch (error) {
      Monitoring.NRError(error, 'MultiCurrencyFieldBase', {
        currencyCodes,
        currencySymbols,
        targetSelector,
      });
    }
  };

  return {
    replaceCurrencySymbol,
  };
};

export default MultiCurrencyFieldBase;
